export default __webpack_public_path__ + "static/media/img-getvaccinated.49402d08.png";